export const getHelmLink = (source: string): string => {
  const lastIndex = source.lastIndexOf(":");
  return source.substr(0, lastIndex) + "/index.yaml";
};
